import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const NotificationsSettings = () => {
  return (
    <SettingsCard title="Notificaciones">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default NotificationsSettings;